import { connect } from 'react-redux'
import Oauth from './oauth'
import { fetchProviders } from '../../../../stores/providers/providers.actions'

const mapDispatchToProps = dispatch => ({
  onMount: () => dispatch(fetchProviders())
})

export default connect(
  null,
  mapDispatchToProps
)(Oauth)
